/* eslint-disable react/display-name */
import React from 'react';
const withContainer = (container,BottomNavigation)=>WrappedComponent=>props=>{
    return <WrappedComponent container={container} BottomNavigation={BottomNavigation}  {...props}/>;
}
export default withContainer;
